<div class="flex-row alert-no-margin">
  <div class="altinn-chapter-line-validation--text-and-icon">
    <span>
      <span class="glyphicon glyphicon-exclamation-sign"></span>
      <ng-content></ng-content>
    </span>
  </div>
</div>
<ng-content select=".checkbox-with-label"></ng-content>
